module.exports = __webpack_public_path__ + "static/media/team-member-05.85746230.png";